module.exports = __webpack_public_path__ + "3b1a45a58cb4040ce36f0cd08b5fb79f.jpg";